import { render, staticRenderFns } from "./ReportLocation.vue?vue&type=template&id=f8976840&scoped=true"
import script from "./ReportLocation.vue?vue&type=script&lang=ts"
export * from "./ReportLocation.vue?vue&type=script&lang=ts"
import style0 from "./ReportLocation.vue?vue&type=style&index=0&id=f8976840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8976840",
  null
  
)

export default component.exports